import { jsx as l, jsxs as t } from "react/jsx-runtime";
import { cn as r } from "@tameeni/shared-logic";
import { Button as a, SelectionInput as o } from "@tameeni/ui";
import "@tameeni/icons";
function s({ title: e }) {
  return /* @__PURE__ */ l("div", { className: "text-h1 lg:text-d2", children: e });
}
function u({ subTitle: e }) {
  return /* @__PURE__ */ l("div", { className: "text-b1 lg:text-h4 text-slate-600", children: e });
}
function g({
  mainLabel: e,
  selectionType: i = "single",
  children: n,
  locale: c
}) {
  return /* @__PURE__ */ t("div", { className: "flex flex-col gap-4", children: [
    /* @__PURE__ */ l("div", { className: "text-t2 lg:text-md font-semibold", children: e }),
    /* @__PURE__ */ l(
      o,
      {
        locale: c,
        size: "lg",
        type: i,
        className: "w-full",
        children: n
      }
    )
  ] });
}
function h(e) {
  return /* @__PURE__ */ l("div", { className: "flex flex-col lg:flex-row gap-4", children: e.children });
}
function N(e) {
  return /* @__PURE__ */ l(
    a,
    {
      onClick: e.onClick,
      variant: e.actionType === "primary" ? "solid" : "text",
      color: "primary",
      size: "lg",
      className: r("w-full md:w-auto", e.className),
      children: e.label
    }
  );
}
function b(e) {
  return /* @__PURE__ */ t("div", { className: "flex flex-col gap-8 z-20 pt-4 pb-8 lg:py-12 justify-center lg:w-3/5", children: [
    /* @__PURE__ */ t("div", { className: "flex flex-col gap-2", children: [
      /* @__PURE__ */ l(s, { title: e.title }),
      !!e.subTitle && /* @__PURE__ */ l(u, { subTitle: e.subTitle })
    ] }),
    e.children
  ] });
}
export {
  N as ActionButton,
  h as Actions,
  b as HeroContent,
  g as Selections
};
//# sourceMappingURL=index.js.map
